// 抽样分母(按照1/rate的比例采样)，1代表100%上报，10代表10%上报，100代表1%上报
const armsRate = +window.__rate || 1;

const DEFAULT_ARMS_CONFIG = {
  pid: window.__pid || 'cbzip5arh8@86cf3629892ad53',
  sample: armsRate,
  pvSample: armsRate,
  disableHook: true,
  useFmp: true,
  ignore: {
    ignoreErrors: [
      'Script error.',
      'The object does not support the operation or argument.',
      'The operation is not supported.',
      'activeEvent is not defined',
      'An attempt was made to break through the security policy of the user agent.',
      "Cannot read property 'dispatchEvent' of undefined",
      "null is not an object (evaluating 'document.querySelector('video').setAttribute')",
      "null is not an object (evaluating 'document.querySelector('video').pause')",
      'Unable to open database file on disk',
      'pp data empty',
      '[NavigationTrace]',
      '$ is not defined',
      'orderButton is null',
      'App is not installed',
      'Attempting to change the getter of an unconfigurable property.',
      `undefined is not an object (evaluating 'window.ucbrowser.pageVideoPaused')`,
      `undefined is not an object (evaluating 'window.ucbrowser.novelHistoryByBookIos')`,
      /(Minified React error #421)/,
      /(请求|取消|过期|超时|网络|调用成功|登录|服务|重试|异常退出|授权失败|会话)/,
      /(AlipayH5Share|Network|Request|Aplus4UT|support|Failed|Load|goldlog.|Session|SESSION|unknown|Internal|indexedDB|ready event)/,
      /(__mapview__rightbutton|isLiveH5|ttJSBridge|WMBridge|WebViewJavascriptBridge|_handleMessageFromNative|_handleMessageFromToutiao|UCShellJava)/,
    ],
  },
};

const ARMS_SCRIPT = '//retcode.alicdn.com/retcode/bl.js';

export { DEFAULT_ARMS_CONFIG, ARMS_SCRIPT };
